/**
 * The Users page on its own, outside any project: `/users`, and `/p/<slug>/users`
 * when that project won't open. Admins manage people, not projects (ADR 033), so
 * an admin in no project still needs a way in. Just a thin top bar and the page.
 */

import { Logo } from "@/components/logo";
import { Toaster } from "@/components/toaster";
import { UsersPage } from "./users-page";

export function UsersScreen() {
  return (
    <div className="min-h-dvh bg-canvas text-ink">
      <header className="flex h-14 items-center gap-2.5 border-b border-line bg-surface px-4 sm:px-8">
        <Logo size={24} />
        <span className="text-[13px] font-semibold">Workbench</span>
        {/* Out of this router: `/` is the root router's, so a full page load. */}
        <a className="link ml-auto text-[13px]" href="/">
          Back to your projects
        </a>
      </header>
      <main className="px-4 py-6 sm:px-8">
        <UsersPage />
      </main>
      <Toaster />
    </div>
  );
}
